/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/~__root'
import { Route as IndexRouteImport } from './routes/~index'
import { Route as OrganizationIdRouteImport } from './routes/~$organizationId'
import { Route as AppRouteImport } from './routes/~app'
import { Route as AuthErrorRouteImport } from './routes/~auth-error'
import { Route as LoginRouteImport } from './routes/~login'
import { Route as OrganizationIdAdminRouteImport } from './routes/~$organizationId/~admin'
import { Route as AppIndexRouteImport } from './routes/~app/~index'
import { Route as OrganizationIdPropertiesSubstationIdRouteImport } from './routes/~$organizationId/~properties/~$substationId'
import { Route as AppActivateAccountActivationCodeRouteImport } from './routes/~app/~activate-account/~$activationCode'
import { Route as OrganizationIdPropertiesSubstationIdEnergyConsumptionRouteImport } from './routes/~$organizationId/~properties/~$substationId/~energy-consumption'
import { Route as OrganizationIdPropertiesSubstationIdEventsRouteImport } from './routes/~$organizationId/~properties/~$substationId/~events'
import { Route as OrganizationIdPropertiesSubstationIdIndoorClimateRouteImport } from './routes/~$organizationId/~properties/~$substationId/~indoor-climate'
import { Route as OrganizationIdPropertiesSubstationIdInsightsRouteImport } from './routes/~$organizationId/~properties/~$substationId/~insights'
import { Route as OrganizationIdPropertiesSubstationIdOptimizationRouteImport } from './routes/~$organizationId/~properties/~$substationId/~optimization'
import { Route as OrganizationIdPropertiesSubstationIdOverviewRouteImport } from './routes/~$organizationId/~properties/~$substationId/~overview'
import { Route as OrganizationIdPropertiesSubstationIdTechnicalDashboardRouteImport } from './routes/~$organizationId/~properties/~$substationId/~technical-dashboard'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationIdRoute = OrganizationIdRouteImport.update({
  id: '/$organizationId',
  path: '/$organizationId',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthErrorRoute = AuthErrorRouteImport.update({
  id: '/auth-error',
  path: '/auth-error',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationIdAdminRoute = OrganizationIdAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => OrganizationIdRoute,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const OrganizationIdPropertiesSubstationIdRoute =
  OrganizationIdPropertiesSubstationIdRouteImport.update({
    id: '/properties/$substationId',
    path: '/properties/$substationId',
    getParentRoute: () => OrganizationIdRoute,
  } as any)
const AppActivateAccountActivationCodeRoute =
  AppActivateAccountActivationCodeRouteImport.update({
    id: '/activate-account/$activationCode',
    path: '/activate-account/$activationCode',
    getParentRoute: () => AppRoute,
  } as any)
const OrganizationIdPropertiesSubstationIdEnergyConsumptionRoute =
  OrganizationIdPropertiesSubstationIdEnergyConsumptionRouteImport.update({
    id: '/energy-consumption',
    path: '/energy-consumption',
    getParentRoute: () => OrganizationIdPropertiesSubstationIdRoute,
  } as any)
const OrganizationIdPropertiesSubstationIdEventsRoute =
  OrganizationIdPropertiesSubstationIdEventsRouteImport.update({
    id: '/events',
    path: '/events',
    getParentRoute: () => OrganizationIdPropertiesSubstationIdRoute,
  } as any)
const OrganizationIdPropertiesSubstationIdIndoorClimateRoute =
  OrganizationIdPropertiesSubstationIdIndoorClimateRouteImport.update({
    id: '/indoor-climate',
    path: '/indoor-climate',
    getParentRoute: () => OrganizationIdPropertiesSubstationIdRoute,
  } as any)
const OrganizationIdPropertiesSubstationIdInsightsRoute =
  OrganizationIdPropertiesSubstationIdInsightsRouteImport.update({
    id: '/insights',
    path: '/insights',
    getParentRoute: () => OrganizationIdPropertiesSubstationIdRoute,
  } as any)
const OrganizationIdPropertiesSubstationIdOptimizationRoute =
  OrganizationIdPropertiesSubstationIdOptimizationRouteImport.update({
    id: '/optimization',
    path: '/optimization',
    getParentRoute: () => OrganizationIdPropertiesSubstationIdRoute,
  } as any)
const OrganizationIdPropertiesSubstationIdOverviewRoute =
  OrganizationIdPropertiesSubstationIdOverviewRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => OrganizationIdPropertiesSubstationIdRoute,
  } as any)
const OrganizationIdPropertiesSubstationIdTechnicalDashboardRoute =
  OrganizationIdPropertiesSubstationIdTechnicalDashboardRouteImport.update({
    id: '/technical-dashboard',
    path: '/technical-dashboard',
    getParentRoute: () => OrganizationIdPropertiesSubstationIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$organizationId': typeof OrganizationIdRouteWithChildren
  '/app': typeof AppRouteWithChildren
  '/auth-error': typeof AuthErrorRoute
  '/login': typeof LoginRoute
  '/app/': typeof AppIndexRoute
  '/$organizationId/admin': typeof OrganizationIdAdminRoute
  '/$organizationId/properties/$substationId': typeof OrganizationIdPropertiesSubstationIdRouteWithChildren
  '/app/activate-account/$activationCode': typeof AppActivateAccountActivationCodeRoute
  '/$organizationId/properties/$substationId/energy-consumption': typeof OrganizationIdPropertiesSubstationIdEnergyConsumptionRoute
  '/$organizationId/properties/$substationId/events': typeof OrganizationIdPropertiesSubstationIdEventsRoute
  '/$organizationId/properties/$substationId/indoor-climate': typeof OrganizationIdPropertiesSubstationIdIndoorClimateRoute
  '/$organizationId/properties/$substationId/insights': typeof OrganizationIdPropertiesSubstationIdInsightsRoute
  '/$organizationId/properties/$substationId/optimization': typeof OrganizationIdPropertiesSubstationIdOptimizationRoute
  '/$organizationId/properties/$substationId/overview': typeof OrganizationIdPropertiesSubstationIdOverviewRoute
  '/$organizationId/properties/$substationId/technical-dashboard': typeof OrganizationIdPropertiesSubstationIdTechnicalDashboardRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$organizationId': typeof OrganizationIdRouteWithChildren
  '/auth-error': typeof AuthErrorRoute
  '/login': typeof LoginRoute
  '/app': typeof AppIndexRoute
  '/$organizationId/admin': typeof OrganizationIdAdminRoute
  '/$organizationId/properties/$substationId': typeof OrganizationIdPropertiesSubstationIdRouteWithChildren
  '/app/activate-account/$activationCode': typeof AppActivateAccountActivationCodeRoute
  '/$organizationId/properties/$substationId/energy-consumption': typeof OrganizationIdPropertiesSubstationIdEnergyConsumptionRoute
  '/$organizationId/properties/$substationId/events': typeof OrganizationIdPropertiesSubstationIdEventsRoute
  '/$organizationId/properties/$substationId/indoor-climate': typeof OrganizationIdPropertiesSubstationIdIndoorClimateRoute
  '/$organizationId/properties/$substationId/insights': typeof OrganizationIdPropertiesSubstationIdInsightsRoute
  '/$organizationId/properties/$substationId/optimization': typeof OrganizationIdPropertiesSubstationIdOptimizationRoute
  '/$organizationId/properties/$substationId/overview': typeof OrganizationIdPropertiesSubstationIdOverviewRoute
  '/$organizationId/properties/$substationId/technical-dashboard': typeof OrganizationIdPropertiesSubstationIdTechnicalDashboardRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$organizationId': typeof OrganizationIdRouteWithChildren
  '/app': typeof AppRouteWithChildren
  '/auth-error': typeof AuthErrorRoute
  '/login': typeof LoginRoute
  '/app/': typeof AppIndexRoute
  '/$organizationId/admin': typeof OrganizationIdAdminRoute
  '/$organizationId/properties/$substationId': typeof OrganizationIdPropertiesSubstationIdRouteWithChildren
  '/app/activate-account/$activationCode': typeof AppActivateAccountActivationCodeRoute
  '/$organizationId/properties/$substationId/energy-consumption': typeof OrganizationIdPropertiesSubstationIdEnergyConsumptionRoute
  '/$organizationId/properties/$substationId/events': typeof OrganizationIdPropertiesSubstationIdEventsRoute
  '/$organizationId/properties/$substationId/indoor-climate': typeof OrganizationIdPropertiesSubstationIdIndoorClimateRoute
  '/$organizationId/properties/$substationId/insights': typeof OrganizationIdPropertiesSubstationIdInsightsRoute
  '/$organizationId/properties/$substationId/optimization': typeof OrganizationIdPropertiesSubstationIdOptimizationRoute
  '/$organizationId/properties/$substationId/overview': typeof OrganizationIdPropertiesSubstationIdOverviewRoute
  '/$organizationId/properties/$substationId/technical-dashboard': typeof OrganizationIdPropertiesSubstationIdTechnicalDashboardRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$organizationId'
    | '/app'
    | '/auth-error'
    | '/login'
    | '/app/'
    | '/$organizationId/admin'
    | '/$organizationId/properties/$substationId'
    | '/app/activate-account/$activationCode'
    | '/$organizationId/properties/$substationId/energy-consumption'
    | '/$organizationId/properties/$substationId/events'
    | '/$organizationId/properties/$substationId/indoor-climate'
    | '/$organizationId/properties/$substationId/insights'
    | '/$organizationId/properties/$substationId/optimization'
    | '/$organizationId/properties/$substationId/overview'
    | '/$organizationId/properties/$substationId/technical-dashboard'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$organizationId'
    | '/auth-error'
    | '/login'
    | '/app'
    | '/$organizationId/admin'
    | '/$organizationId/properties/$substationId'
    | '/app/activate-account/$activationCode'
    | '/$organizationId/properties/$substationId/energy-consumption'
    | '/$organizationId/properties/$substationId/events'
    | '/$organizationId/properties/$substationId/indoor-climate'
    | '/$organizationId/properties/$substationId/insights'
    | '/$organizationId/properties/$substationId/optimization'
    | '/$organizationId/properties/$substationId/overview'
    | '/$organizationId/properties/$substationId/technical-dashboard'
  id:
    | '__root__'
    | '/'
    | '/$organizationId'
    | '/app'
    | '/auth-error'
    | '/login'
    | '/app/'
    | '/$organizationId/admin'
    | '/$organizationId/properties/$substationId'
    | '/app/activate-account/$activationCode'
    | '/$organizationId/properties/$substationId/energy-consumption'
    | '/$organizationId/properties/$substationId/events'
    | '/$organizationId/properties/$substationId/indoor-climate'
    | '/$organizationId/properties/$substationId/insights'
    | '/$organizationId/properties/$substationId/optimization'
    | '/$organizationId/properties/$substationId/overview'
    | '/$organizationId/properties/$substationId/technical-dashboard'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  OrganizationIdRoute: typeof OrganizationIdRouteWithChildren
  AppRoute: typeof AppRouteWithChildren
  AuthErrorRoute: typeof AuthErrorRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationId': {
      id: '/$organizationId'
      path: '/$organizationId'
      fullPath: '/$organizationId'
      preLoaderRoute: typeof OrganizationIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth-error': {
      id: '/auth-error'
      path: '/auth-error'
      fullPath: '/auth-error'
      preLoaderRoute: typeof AuthErrorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$organizationId/admin': {
      id: '/$organizationId/admin'
      path: '/admin'
      fullPath: '/$organizationId/admin'
      preLoaderRoute: typeof OrganizationIdAdminRouteImport
      parentRoute: typeof OrganizationIdRoute
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/$organizationId/properties/$substationId': {
      id: '/$organizationId/properties/$substationId'
      path: '/properties/$substationId'
      fullPath: '/$organizationId/properties/$substationId'
      preLoaderRoute: typeof OrganizationIdPropertiesSubstationIdRouteImport
      parentRoute: typeof OrganizationIdRoute
    }
    '/app/activate-account/$activationCode': {
      id: '/app/activate-account/$activationCode'
      path: '/activate-account/$activationCode'
      fullPath: '/app/activate-account/$activationCode'
      preLoaderRoute: typeof AppActivateAccountActivationCodeRouteImport
      parentRoute: typeof AppRoute
    }
    '/$organizationId/properties/$substationId/energy-consumption': {
      id: '/$organizationId/properties/$substationId/energy-consumption'
      path: '/energy-consumption'
      fullPath: '/$organizationId/properties/$substationId/energy-consumption'
      preLoaderRoute: typeof OrganizationIdPropertiesSubstationIdEnergyConsumptionRouteImport
      parentRoute: typeof OrganizationIdPropertiesSubstationIdRoute
    }
    '/$organizationId/properties/$substationId/events': {
      id: '/$organizationId/properties/$substationId/events'
      path: '/events'
      fullPath: '/$organizationId/properties/$substationId/events'
      preLoaderRoute: typeof OrganizationIdPropertiesSubstationIdEventsRouteImport
      parentRoute: typeof OrganizationIdPropertiesSubstationIdRoute
    }
    '/$organizationId/properties/$substationId/indoor-climate': {
      id: '/$organizationId/properties/$substationId/indoor-climate'
      path: '/indoor-climate'
      fullPath: '/$organizationId/properties/$substationId/indoor-climate'
      preLoaderRoute: typeof OrganizationIdPropertiesSubstationIdIndoorClimateRouteImport
      parentRoute: typeof OrganizationIdPropertiesSubstationIdRoute
    }
    '/$organizationId/properties/$substationId/insights': {
      id: '/$organizationId/properties/$substationId/insights'
      path: '/insights'
      fullPath: '/$organizationId/properties/$substationId/insights'
      preLoaderRoute: typeof OrganizationIdPropertiesSubstationIdInsightsRouteImport
      parentRoute: typeof OrganizationIdPropertiesSubstationIdRoute
    }
    '/$organizationId/properties/$substationId/optimization': {
      id: '/$organizationId/properties/$substationId/optimization'
      path: '/optimization'
      fullPath: '/$organizationId/properties/$substationId/optimization'
      preLoaderRoute: typeof OrganizationIdPropertiesSubstationIdOptimizationRouteImport
      parentRoute: typeof OrganizationIdPropertiesSubstationIdRoute
    }
    '/$organizationId/properties/$substationId/overview': {
      id: '/$organizationId/properties/$substationId/overview'
      path: '/overview'
      fullPath: '/$organizationId/properties/$substationId/overview'
      preLoaderRoute: typeof OrganizationIdPropertiesSubstationIdOverviewRouteImport
      parentRoute: typeof OrganizationIdPropertiesSubstationIdRoute
    }
    '/$organizationId/properties/$substationId/technical-dashboard': {
      id: '/$organizationId/properties/$substationId/technical-dashboard'
      path: '/technical-dashboard'
      fullPath: '/$organizationId/properties/$substationId/technical-dashboard'
      preLoaderRoute: typeof OrganizationIdPropertiesSubstationIdTechnicalDashboardRouteImport
      parentRoute: typeof OrganizationIdPropertiesSubstationIdRoute
    }
  }
}

interface OrganizationIdPropertiesSubstationIdRouteChildren {
  OrganizationIdPropertiesSubstationIdEnergyConsumptionRoute: typeof OrganizationIdPropertiesSubstationIdEnergyConsumptionRoute
  OrganizationIdPropertiesSubstationIdEventsRoute: typeof OrganizationIdPropertiesSubstationIdEventsRoute
  OrganizationIdPropertiesSubstationIdIndoorClimateRoute: typeof OrganizationIdPropertiesSubstationIdIndoorClimateRoute
  OrganizationIdPropertiesSubstationIdInsightsRoute: typeof OrganizationIdPropertiesSubstationIdInsightsRoute
  OrganizationIdPropertiesSubstationIdOptimizationRoute: typeof OrganizationIdPropertiesSubstationIdOptimizationRoute
  OrganizationIdPropertiesSubstationIdOverviewRoute: typeof OrganizationIdPropertiesSubstationIdOverviewRoute
  OrganizationIdPropertiesSubstationIdTechnicalDashboardRoute: typeof OrganizationIdPropertiesSubstationIdTechnicalDashboardRoute
}

const OrganizationIdPropertiesSubstationIdRouteChildren: OrganizationIdPropertiesSubstationIdRouteChildren =
  {
    OrganizationIdPropertiesSubstationIdEnergyConsumptionRoute:
      OrganizationIdPropertiesSubstationIdEnergyConsumptionRoute,
    OrganizationIdPropertiesSubstationIdEventsRoute:
      OrganizationIdPropertiesSubstationIdEventsRoute,
    OrganizationIdPropertiesSubstationIdIndoorClimateRoute:
      OrganizationIdPropertiesSubstationIdIndoorClimateRoute,
    OrganizationIdPropertiesSubstationIdInsightsRoute:
      OrganizationIdPropertiesSubstationIdInsightsRoute,
    OrganizationIdPropertiesSubstationIdOptimizationRoute:
      OrganizationIdPropertiesSubstationIdOptimizationRoute,
    OrganizationIdPropertiesSubstationIdOverviewRoute:
      OrganizationIdPropertiesSubstationIdOverviewRoute,
    OrganizationIdPropertiesSubstationIdTechnicalDashboardRoute:
      OrganizationIdPropertiesSubstationIdTechnicalDashboardRoute,
  }

const OrganizationIdPropertiesSubstationIdRouteWithChildren =
  OrganizationIdPropertiesSubstationIdRoute._addFileChildren(
    OrganizationIdPropertiesSubstationIdRouteChildren,
  )

interface OrganizationIdRouteChildren {
  OrganizationIdAdminRoute: typeof OrganizationIdAdminRoute
  OrganizationIdPropertiesSubstationIdRoute: typeof OrganizationIdPropertiesSubstationIdRouteWithChildren
}

const OrganizationIdRouteChildren: OrganizationIdRouteChildren = {
  OrganizationIdAdminRoute: OrganizationIdAdminRoute,
  OrganizationIdPropertiesSubstationIdRoute:
    OrganizationIdPropertiesSubstationIdRouteWithChildren,
}

const OrganizationIdRouteWithChildren = OrganizationIdRoute._addFileChildren(
  OrganizationIdRouteChildren,
)

interface AppRouteChildren {
  AppIndexRoute: typeof AppIndexRoute
  AppActivateAccountActivationCodeRoute: typeof AppActivateAccountActivationCodeRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppIndexRoute: AppIndexRoute,
  AppActivateAccountActivationCodeRoute: AppActivateAccountActivationCodeRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  OrganizationIdRoute: OrganizationIdRouteWithChildren,
  AppRoute: AppRouteWithChildren,
  AuthErrorRoute: AuthErrorRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

export type RouteId = Exclude<keyof FileRoutesById, '__root__'>

export type Route = FileRoutesById[RouteId]

export type RouteTree = typeof routeTree
